module.exports = __webpack_public_path__ + "img/image_07.5dd6363c.png";